import { render, staticRenderFns } from "./BienVendu.vue?vue&type=template&id=58598b38&v-loading=loading&"
import script from "./BienVendu.vue?vue&type=script&lang=js&"
export * from "./BienVendu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports